<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Currencies</h3>
                        </div><!-- .nk-block-head-content -->
                        <div class="nk-block-head-content">
                            <div class="toggle-wrap nk-block-tools-toggle">
                                <a href="#" class="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em class="icon ni ni-more-v"></em></a>
                                <div class="toggle-expand-content" data-content="pageMenu">
                                    <ul class="nk-block-tools g-3">
                                        <li>
                                            <div class="form-control-wrap">
                                                <div class="form-icon form-icon-right">
                                                    <em class="icon ni ni-search"></em>
                                                </div>
                                                <input v-model="search" type="text" class="form-control" id="default-04" placeholder="Quick search">
                                            </div>
                                        </li>
                                        <li class="nk-block-tools-opt">
                                            <a href="javascript:void(0)" v-on:click="AddSignup()"  data-target="addProduct" class="toggle btn btn-icon btn-primary d-md-none"><em class="icon ni ni-plus"></em></a>
                                            <a href="javascript:void(0)" v-on:click="AddSignup()" data-target="addProduct" class="toggle btn btn-primary d-none d-md-inline-flex"><em class="icon ni ni-plus"></em><span>Add Currency</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div><!-- .nk-block-head-content -->
                    </div><!-- .nk-block-between -->
                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="card card-bordered">
                        <div class="card-inner-group">
                            <div class="card-inner p-0">
                                <div class="nk-tb-list">
                                    <div class="nk-tb-item nk-tb-head">
                                        <div class="nk-tb-col nk-tb-col-check">
                                            <div class="custom-control custom-control-sm custom-checkbox notext">
                                                <input type="checkbox" class="custom-control-input" id="pid">
                                                <label class="custom-control-label" for="pid"></label>
                                            </div>
                                        </div>
                                        <div class="nk-tb-col tb-col-sm"><span>Name</span></div>
                                        <div class="nk-tb-col"><span>Money</span></div>
                                        <div class="nk-tb-col"><span>Rate</span></div>
                                        <div class="nk-tb-col"><span>Status</span></div>
                                        <div class="nk-tb-col nk-tb-col-tools">
                                            <!--<ul class="nk-tb-actions gx-1 my-n1">
                                                <li class="me-n1">
                                                    <div class="dropdown">
                                                        <a href="#" class="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                                                        <div class="dropdown-menu dropdown-menu-end">
                                                            <ul class="link-list-opt no-bdr">-->
                                                                <!--<li><a href="#"><em class="icon ni ni-edit"></em><span>Edit</span></a></li>-->
                                                            <!--</ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>-->
                                        </div>
                                    </div><!-- .nk-tb-item -->
                                    <div class="nk-tb-item" v-for="(details) in userList" v-bind:key="details.id">
                                        <div class="nk-tb-col nk-tb-col-check">
                                            <div class="custom-control custom-control-sm custom-checkbox notext">
                                                <input type="checkbox" class="custom-control-input" id="pid1">
                                                <label class="custom-control-label" for="pid1"></label>
                                            </div>
                                        </div>
                                        <div class="nk-tb-col tb-col-sm">
                                            <span class="tb-product">
                                                <img :src="'data:image/png;base64,' + details.image" alt="" class="thumb">
                                                <span class="title">{{details.name}}</span>
                                            </span>
                                        </div>
                                        <div class="nk-tb-col">
                                            <span class="tb-sub">{{details.money}}</span>
                                        </div>
                                        <div class="nk-tb-col">
                                            <span class="tb-lead">{{details.rate}}</span>
                                        </div>
                                        <div class="nk-tb-col">
                                            <span v-if="details.isActive" class="badge badge-dot bg-success">Active</span>
                                            <span v-if="!details.isActive" class="badge badge-dot bg-danger">In-Active</span>
                                        </div>
                                        <div class="nk-tb-col nk-tb-col-tools">
                                            <ul class="nk-tb-actions gx-1 my-n1">
                                                <li class="me-n1">
                                                    <div class="dropdown">
                                                        <a href="#" class="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                                                        <div class="dropdown-menu dropdown-menu-end">
                                                            <ul class="link-list-opt no-bdr">
                                                                <li><a v-on:click="EditInfo(details.id)" href="javascript:void(0)"><em class="icon ni ni-edit-alt"></em><span>Edit</span></a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div><!-- .nk-tb-item -->
                                </div><!-- .nk-tb-list -->
                            </div>
                            <div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div><!-- .pagination -->
                                    </div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div><!-- .pagination-goto -->
                                </div><!-- .nk-block-between -->
                            </div>
                        </div>
                    </div>
                </div><!-- .nk-block -->
            </div>
        </div>
    </div>


    <!--<div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head nk-block-head-sm">
                    <div class="nk-block-between g-3">
                        <div class="nk-block-head-content">
                            <h3 class="nk-block-title page-title">Currencies</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} Currency.</p>
                            </div>
                        </div>--><!-- .nk-block-head-content -->
                        <!--<div class="nk-block-head-content">
                            <a href="javascript:void(0)" v-on:click="AddSignup()" class="btn btn-icon btn-primary"><em class="icon ni ni-plus"></em></a>

                        </div>--><!-- .nk-block-head-content -->
                    <!--</div>--><!-- .nk-block-between -->
                <!--</div>--><!-- .nk-block-head -->
                <!--<div class="nk-block">
                    <div class="card card-bordered card-stretch">
                        <div class="card-inner-group">
                            <div class="card-inner p-0">
                                <table class="table table-tranx">
                                    <thead>
                                        <tr class="tb-tnx-head">
                                            <th class="tb-tnx-info">#</th>
                                            <th class="tb-tnx-info">
                                                Image
                                            </th>
                                            <th class="tb-tnx-info">
                                                Name
                                            </th>
                                            <th class="tb-tnx-info">
                                                Money
                                            </th>
                                            <th class="tb-tnx-info">
                                                Rate
                                            </th>
                                            <th class="tb-tnx-action">
                                                <span>&nbsp;</span>
                                            </th>
                                        </tr>--><!-- tb-tnx-item -->
                                    <!--</thead>
                                    <tbody>
                                        <tr v-for="(details, index) in userList" v-bind:key="details.id" class="tb-tnx-item">
                                            <td class="tb-tnx-info" v-if="currentPage === 1">
                                                {{index+1}}
                                            </td>
                                            <td class="tb-tnx-info" v-else>
                                                {{((currentPage*10)-10) +(index+1)}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.code}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                {{details.name}}
                                            </td>
                                            <td class="tb-tnx-info">
                                                <span v-if="details.isActive" class="badge badge-dot bg-success">Active</span>
                                                <span v-else class="badge badge-dot bg-warning">In-Active</span>
                                            </td>
                                            <td class="tb-tnx-info">
                                                <span v-if="details.isActive" class="badge badge-dot bg-success">Active</span>
                                                <span v-else class="badge badge-dot bg-warning">In-Active</span>
                                            </td>
                                            <td class="tb-tnx-action">
                                                <div class="dropdown">
                                                    <a class="text-soft dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em class="icon ni ni-more-h"></em></a>
                                                    <div class="dropdown-menu dropdown-menu-end dropdown-menu-xs">
                                                        <ul class="link-list-plain">
                                                            <li><a v-on:click="EditInfo(details.id)" href="javascript:void(0)">Edit</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>--><!-- tb-tnx-item -->
                                    <!--</tbody>
                                </table>
                            </div>--><!-- .card-inner -->
                            <!--<div class="card-inner">
                                <div class="nk-block-between-md g-3">
                                    <div class="g">
                                        <div class="pagination justify-content-center justify-content-md-start">
                                            <div class="overflow-auto" v-on:click="getPage()">
                                                <b-pagination pills size="md" v-model="currentPage"
                                                              :total-rows="rowCount"
                                                              :per-page="10"
                                                              first-text="First"
                                                              prev-text="Previous"
                                                              next-text="Next"
                                                              last-text="Last"></b-pagination>
                                            </div>
                                        </div>--><!-- .pagination -->
                                    <!--</div>
                                    <div class="g">
                                        <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                            <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                            <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                            <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                        </div>
                                    </div>--><!-- .pagination-goto -->
                                <!--</div>--><!-- .nk-block-between -->
                            <!--</div>--><!-- .card-inner -->
                        <!--</div>--><!-- .card-inner-group -->
                    <!--</div>--><!-- .card -->
                <!--</div>--><!-- .nk-block -->
            <!--</div>
        </div>
    </div>-->

</template>
<script>
    export default {
        name: 'BankList',
        data: function () {
            return {
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',
                isDesc: false,

                loading: false,
                userList: [],

            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {
            
            AddSignup: function () {
                this.$router.push('/AddCurrency')
            },

            getPageSize: function (isDesc) {
                this.isDesc = isDesc;
                this.getPage();
            },
            
            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Company/CurrencyList?searchTerm=' + search + '&pageNumber=' + currentPage;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                            icon: 'error',
                            type: 'error',
                            title: 'Error',
                            text: "Something Went Wrong",
                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });
                }).finally(() => root.loading = false);
            },


            EditInfo: function (id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Company/GetCurrencyDetail?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {

                        root.$router.push({
                            path: '/AddCurrency',
                            query: { data: response.data }
                        })
                    }
                });
            },

        },
        created: function () {
        },
        mounted: function () {
            this.GetData(this.search, 1);
        },
    }
</script>